import { objectToSnakeCase, objectToCamelCase } from '../utils'
import moment from 'moment'

import api from './api'
import Answer from '@/services/answers'

export default class Question {
  static api = api.create(Question)
  static readOnlyFields = ['id']

  constructor({
    id = null,
    datetimeCreated = '',
    lastEdited = '',
    text = '',
    upvotes = 0,
    project = '',
    authorRef = {},
    answersRef = {},
    date = '',
    photos = [],
  } = {}) {
    Object.assign(this, {
      id,
      datetimeCreated,
      lastEdited,
      text,
      upvotes,
      project,
      authorRef,
      answersRef,
      date,
      photos,
    })
  }

  get formattedDatetimeCreated() {
    //accounting for error "Invalid date" if endDate is unable to be coerced into specified format
    //will reset datetimeCreated to null if error occurs
    const dateFormatForUI = moment(this.datetimeCreated).format('YYYY-MM-DDTHH:mm')
    if (!dateFormatForUI || dateFormatForUI === 'Invalid date') {
      return null
    } else {
      return dateFormatForUI
    }
  }

  copy() {
    return new Question(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    if (data.answersRef) {
      data.answersRef = data.answersRef.map(Answer.create)
    }
    return new Question(data)
  }

  static fromAPI(json = {}) {
    const jsonCamel = objectToCamelCase(json)
    if (jsonCamel.answersRef) {
      jsonCamel.answersRef = jsonCamel.answersRef.map(Answer.fromAPI)
    }
    return new Question(jsonCamel)
  }
  /**
   *  Prep Question data for the API. Can elect to include
   *  or exlude specific fields. The `Question.readOnlyFields`
   *  are always excluded.
   **/
  static toAPI(question, fields = [], excludeFields = []) {
    // By default, send the whole update
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = question[field]
      })
    } else {
      data = question
    }

    excludeFields = [...Question.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Question)) {
      throw Error(`${name} must be an instance of the Question class.`)
    }
  }
}
